import React from 'react';
import { Briefcase, Mail, Linkedin, Twitter, Calendar, MapPin, Award, Layers, Users } from 'lucide-react';
export const Portfolio = () => {
  return <div className="w-full bg-white min-h-screen" data-id="element-3591">
      {/* Hero Section */}
      <section className="pt-20 pb-16 border-b border-gray-200" data-id="element-3592">
        <div className="container mx-auto px-4" data-id="element-3593">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-3594">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-3595">
              <div className="w-64 h-64 border-2 border-gray-300 rounded-full overflow-hidden" data-id="element-3596">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGA11gNJc7vxEwMehjwPFv/dreyyyy.jpg" alt="Andrew Igbineweka" className="w-full h-full object-cover grayscale" loading="eager" width="256" height="256" data-id="element-3597" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-3598">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-3599">
                Andrew Igbineweka
              </h1>
              <h2 className="text-2xl text-gray-600 mb-6" data-id="element-3600">
                Human Capital Development Professional
              </h2>
              <p className="text-gray-600 mb-6 max-w-2xl" data-id="element-3601">
                Passionate about connecting people to networks, ideas, and
                opportunities. Experienced in community building, strategic
                partnerships, and talent development.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-3602">
                <a href="mailto:andrew@example.com" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-3603">
                  <Mail size={16} className="text-gray-600" data-id="element-3604" />
                  <span data-id="element-3605">Contact</span>
                </a>
                <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-3606">
                  <Linkedin size={16} className="text-gray-600" data-id="element-3607" />
                  <span data-id="element-3608">LinkedIn</span>
                </a>
                <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-3609">
                  <Twitter size={16} className="text-gray-600" data-id="element-3610" />
                  <span data-id="element-3611">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-3612">
        <div className="container mx-auto px-4" data-id="element-3613">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-3614">
            About Me
          </h2>
          <div className="flex flex-col md:flex-row gap-12" data-id="element-3615">
            <div className="w-full md:w-2/3" data-id="element-3616">
              <p className="text-gray-600 mb-6" data-id="element-3617">
                I am a Human Capital Development Professional with expertise in
                community building, strategic partnerships, and talent
                development. My work focuses on connecting young professionals
                to networks, ideas, and opportunities worldwide.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-3618">
                As the founder of The Networking Salon, I've built communities
                across multiple cities, creating platforms for meaningful
                connections and professional growth.
              </p>
              <p className="text-gray-600" data-id="element-3619">
                My approach combines strategic thinking with human-centered
                design, creating systems and experiences that help individuals
                and organizations thrive in today's rapidly evolving landscape.
              </p>
            </div>
            <div className="w-full md:w-1/3" data-id="element-3620">
              <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-3621">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3622">
                  Details
                </h3>
                <ul className="space-y-4" data-id="element-3623">
                  <li className="flex items-center gap-3" data-id="element-3624">
                    <Calendar size={20} className="text-gray-500" data-id="element-3625" />
                    <div data-id="element-3626">
                      <p className="text-sm text-gray-500" data-id="element-3627">Experience</p>
                      <p className="text-gray-700" data-id="element-3628">7+ Years</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-3629">
                    <MapPin size={20} className="text-gray-500" data-id="element-3630" />
                    <div data-id="element-3631">
                      <p className="text-sm text-gray-500" data-id="element-3632">Location</p>
                      <p className="text-gray-700" data-id="element-3633">Nigeria</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-3634">
                    <Award size={20} className="text-gray-500" data-id="element-3635" />
                    <div data-id="element-3636">
                      <p className="text-sm text-gray-500" data-id="element-3637">Education</p>
                      <p className="text-gray-700" data-id="element-3638">
                        MBA, University of Nigeria
                      </p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-3639">
                    <Layers size={20} className="text-gray-500" data-id="element-3640" />
                    <div data-id="element-3641">
                      <p className="text-sm text-gray-500" data-id="element-3642">Focus Areas</p>
                      <p className="text-gray-700" data-id="element-3643">
                        Community Building, Strategic Partnerships, Talent
                        Development
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tools Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3644">
        <div className="container mx-auto px-4" data-id="element-3645">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-3646">
            Tools & Skills
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3647">
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3648">
              <div className="flex items-center gap-3 mb-4" data-id="element-3649">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3650">
                  <div size={20} className="text-gray-600" data-id="element-3651" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3652">
                  Strategic Planning
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-3653">
                <li className="flex items-center gap-2" data-id="element-3654">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3655"></div>
                  <span className="text-gray-600" data-id="element-3656">Stakeholder Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3657">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3658"></div>
                  <span className="text-gray-600" data-id="element-3659">SWOT Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3660">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3661"></div>
                  <span className="text-gray-600" data-id="element-3662">Project Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3663">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3664"></div>
                  <span className="text-gray-600" data-id="element-3665">Risk Assessment</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3666">
              <div className="flex items-center gap-3 mb-4" data-id="element-3667">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3668">
                  <Users size={20} className="text-gray-600" data-id="element-3669" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3670">
                  Community Building
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-3671">
                <li className="flex items-center gap-2" data-id="element-3672">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3673"></div>
                  <span className="text-gray-600" data-id="element-3674">Event Planning</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3675">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3676"></div>
                  <span className="text-gray-600" data-id="element-3677">Member Engagement</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3678">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3679"></div>
                  <span className="text-gray-600" data-id="element-3680">Content Creation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3681">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3682"></div>
                  <span className="text-gray-600" data-id="element-3683">Relationship Management</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3684">
              <div className="flex items-center gap-3 mb-4" data-id="element-3685">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3686">
                  <Briefcase size={20} className="text-gray-600" data-id="element-3687" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3688">
                  Business Development
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-3689">
                <li className="flex items-center gap-2" data-id="element-3690">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3691"></div>
                  <span className="text-gray-600" data-id="element-3692">Partnership Building</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3693">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3694"></div>
                  <span className="text-gray-600" data-id="element-3695">Negotiation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3696">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3697"></div>
                  <span className="text-gray-600" data-id="element-3698">
                    Client Relationship Management
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3699">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3700"></div>
                  <span className="text-gray-600" data-id="element-3701">Revenue Strategy</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3702">
              <div className="flex items-center gap-3 mb-4" data-id="element-3703">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3704">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-3705"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3706">
                  Digital Tools
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-3707">
                <li className="flex items-center gap-2" data-id="element-3708">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3709"></div>
                  <span className="text-gray-600" data-id="element-3710">Microsoft Office Suite</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3711">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3712"></div>
                  <span className="text-gray-600" data-id="element-3713">Google Workspace</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3714">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3715"></div>
                  <span className="text-gray-600" data-id="element-3716">Canva</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3717">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3718"></div>
                  <span className="text-gray-600" data-id="element-3719">CRM Systems</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3720">
              <div className="flex items-center gap-3 mb-4" data-id="element-3721">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3722">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-3723"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3724">
                  Communication
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-3725">
                <li className="flex items-center gap-2" data-id="element-3726">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3727"></div>
                  <span className="text-gray-600" data-id="element-3728">Public Speaking</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3729">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3730"></div>
                  <span className="text-gray-600" data-id="element-3731">Content Writing</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3732">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3733"></div>
                  <span className="text-gray-600" data-id="element-3734">Presentation Design</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3735">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3736"></div>
                  <span className="text-gray-600" data-id="element-3737">Storytelling</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-3738">
              <div className="flex items-center gap-3 mb-4" data-id="element-3739">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-3740">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-3741"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3742">Leadership</h3>
              </div>
              <ul className="space-y-2" data-id="element-3743">
                <li className="flex items-center gap-2" data-id="element-3744">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3745"></div>
                  <span className="text-gray-600" data-id="element-3746">Team Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3747">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3748"></div>
                  <span className="text-gray-600" data-id="element-3749">Mentoring</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3750">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3751"></div>
                  <span className="text-gray-600" data-id="element-3752">Conflict Resolution</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-3753">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3754"></div>
                  <span className="text-gray-600" data-id="element-3755">Decision Making</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-3756">
        <div className="container mx-auto px-4" data-id="element-3757">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-3758">
            Professional Experience
          </h2>
          <div className="space-y-8" data-id="element-3759">
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-3760">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-3761">
                <div data-id="element-3762">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-3763">
                    Founder & CEO
                  </h3>
                  <p className="text-gray-600" data-id="element-3764">The Networking Salon</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-3765">2018 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-3766">
                <li data-id="element-3767">
                  Founded and scaled a global community initiative connecting
                  young professionals across 25+ cities worldwide
                </li>
                <li data-id="element-3768">
                  Developed strategic partnerships with organizations to create
                  opportunities for community members
                </li>
                <li data-id="element-3769">
                  Designed and implemented community-building frameworks and
                  engagement strategies
                </li>
                <li data-id="element-3770">
                  Led a team of city leads and volunteers to execute the vision
                  in multiple locations
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-3771">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-3772">
                <div data-id="element-3773">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-3774">
                    Human Capital Development Consultant
                  </h3>
                  <p className="text-gray-600" data-id="element-3775">Various Organizations</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-3776">2016 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-3777">
                <li data-id="element-3778">
                  Provided strategic guidance on talent development and
                  organizational culture
                </li>
                <li data-id="element-3779">
                  Designed and facilitated leadership development programs and
                  workshops
                </li>
                <li data-id="element-3780">
                  Implemented community-building strategies for corporate
                  clients
                </li>
                <li data-id="element-3781">Advised on employee engagement and retention strategies</li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-3782">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-3783">
                <div data-id="element-3784">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-3785">
                    Community Manager
                  </h3>
                  <p className="text-gray-600" data-id="element-3786">Tech Innovation Hub</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-3787">2015 - 2018</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-3788">
                <li data-id="element-3789">
                  Managed a community of tech entrepreneurs and innovators
                </li>
                <li data-id="element-3790">
                  Organized networking events, workshops, and skill-building
                  programs
                </li>
                <li data-id="element-3791">
                  Facilitated connections between community members and
                  potential investors/partners
                </li>
                <li data-id="element-3792">
                  Created content and communications strategies for community
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Brands Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3793">
        <div className="container mx-auto px-4" data-id="element-3794">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-3795">
            Brands I've Worked With
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-3796">
            {/* Brand logos would go here - using placeholders for wireframe */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => <div key={item} className="flex items-center justify-center p-4 border border-gray-300 rounded-lg h-24" data-id="element-3797">
                <div className="w-16 h-8 bg-gray-300 rounded-md" data-id="element-3798"></div>
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-8" data-id="element-3799">
            Note: These are placeholder blocks for brand logos you've worked
            with. You'll need to add actual logos of brands from your
            experience.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-3800">
        <div className="container mx-auto px-4" data-id="element-3801">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-3802">
            Get In Touch
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-3803">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-3804">
              <a href="mailto:andrew@example.com" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-3805">
                <Mail size={32} className="text-gray-600 mb-3" data-id="element-3806" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-3807">Email</h3>
                <p className="text-gray-600 text-center" data-id="element-3808">andrew@example.com</p>
              </a>
              <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-3809">
                <Linkedin size={32} className="text-gray-600 mb-3" data-id="element-3810" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-3811">
                  LinkedIn
                </h3>
                <p className="text-gray-600 text-center" data-id="element-3812">andrewigbineweka</p>
              </a>
              <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-3813">
                <Twitter size={32} className="text-gray-600 mb-3" data-id="element-3814" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-3815">
                  Twitter
                </h3>
                <p className="text-gray-600 text-center" data-id="element-3816">@andrewigbineweka</p>
              </a>
            </div>
            <div className="text-center" data-id="element-3817">
              <p className="text-gray-600 mb-6" data-id="element-3818">
                Interested in working together? I'm always open to discussing
                new projects, opportunities and partnerships.
              </p>
              <a href="mailto:andrew@example.com" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-colors" data-id="element-3819">
                <Mail size={18} data-id="element-3820" />
                <span className="font-bold" data-id="element-3821">Send Me a Message</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 bg-gray-50" data-id="element-3822">
        <div className="container mx-auto px-4 text-center" data-id="element-3823">
          <p className="text-gray-600" data-id="element-3824">
            &copy; {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
};